import { Button } from 'core/components';
import classNames from 'classnames';
import React from 'react';

interface Props {
  on: boolean;
  disabled?: boolean;
  name?: string;
  onToggle: () => void;
}

export default function ToggleFilterButton({ on, disabled, name = 'filter', onToggle }: Props) {
  return (
    <Button
      className={classNames('toggle', { 'toggle-off': !on })}
      disabled={disabled}
      icon={on ? 'eye-open' : 'eye-off'}
      iconColor="muted"
      minimal
      small
      title={`${on ? 'Disable' : 'Enable'} ${name}`}
      onClick={onToggle}
      ml="auto"
      alignSelf="flex-start"
      aria-pressed={on}
    />
  );
}
